import {handleRequest} from './base';

const ManagerRepo = {
  fetch: (bizID) => {
    return handleRequest({
      method: 'get',
      url: `/api/business/${bizID}/managers`,
    })
  },

  create: (bizID, { email }) => {
    const data = {
      email: email,
    };
    return handleRequest({
      method: 'post',
      url: `/api/business/${bizID}/managers`,
      data: data,
    })
  },

  update: (bizID, managerID, { email }) => {
    const data = {
      email: email,
    };
    return handleRequest({
      method: 'patch',
      url: `/api/business/${bizID}/managers/${managerID}`,
      data: data,
    })
  },

  revoke: (bizID, managerID) => {
    return handleRequest({
      method: 'delete',
      url: `/api/business/${bizID}/managers/${managerID}`,
    })
  },

  unrevoke: (bizID, managerID) => {
    return handleRequest({
      method: 'post',
      url: `/api/business/${bizID}/managers/${managerID}/unrevoke`,
    })
  }
};

export default ManagerRepo;
